import React from "react";
import { MapReportTitle } from "../mapSchema";
import ReportTableSectionRenderer from "../../../../../libraries/ReportGenerator";
import { GandOAnnualReportSchema } from "./Schema";
import { getSupportingDocuments } from "../../AirBrakeReports/AirBrakeReports/CommonFunctions";
const titleOfReport = (testCode) => MapReportTitle[testCode];
function GandOAnnualReport(props) {
  const { singleReport } = props;
  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        {GandOAnnualReportSchema.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
}

export default GandOAnnualReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/GAndOAnnual/index.jsx